import { getVisibleSelectionRect } from "draft-js";
import { getScrollParent } from "../../EasyProjectsCommon/getScrollParent";

const scrollToSelection = () => {
    const node = window.getSelection?.().focusNode?.parentNode as HTMLElement;

    if (!node) {
        return;
    }

    const parent = getScrollParent(node);
    if (!parent) {
        return;
    }

    const nodeRect = getVisibleSelectionRect(window);
    if (!nodeRect) {
        return;
    }
    const parentRect = parent.getBoundingClientRect();

    if (nodeRect.top < parentRect.top || nodeRect.bottom > parentRect.bottom) {
        setTimeout(function () {
            node.scrollIntoView({ block: "start" });
        }, 100);
    }
};

export const scrollSelectionIntoView = () => {
    try {
        scrollToSelection();
    } catch {
        // ignore error
    }
};
